import SyntaxUIThemeColors from '@uikit/ui-syntax/dist/js/red-fire-brick';
import { rgba } from './utils/color-utils';
import prepareThemeColors from './utils/theme';


export default prepareThemeColors('red-fire-brick', SyntaxUIThemeColors, {
  '--av-nav-light': '#8a0914', // removed, fallback
  '--av-nav-lightest': rgba('#d5474d', 0.3) // @fixme: removed?
});
